import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'core/components';
import DeviceModel from 'app/stores/device/DeviceModel';
import DeviceConfigs from 'app/views/infrastructure/DeviceConfigs';
import ToolResultCard from '../components/ToolResultCard';

class DeviceConfigToolResult extends Component {
  static propTypes = {
    tool: PropTypes.object.isRequired,
    onCloseToolResult: PropTypes.func,
    isInlineMode: PropTypes.bool
  };

  static defaultProps = {
    onCloseToolResult: () => {},
    isInlineMode: false
  };

  state = {
    device: null
  };

  componentDidMount() {
    this.createDeviceModel().then((device) => {
      if (device) {
        return device.fetch();
      }
      return null;
    });
  }

  componentDidUpdate(prevProps) {
    const { tool } = this.props;
    const { tool: prevTool } = prevProps;

    // Recreate device model if tool data changes
    if (tool.raw_result !== prevTool.raw_result || tool.query_object !== prevTool.query_object) {
      this.createDeviceModel().then((device) => {
        if (device) {
          return device.fetch();
        }
        return null;
      });
    }
  }

  createDeviceModel = () => {
    const { tool } = this.props;
    const { query_object = {} } = tool;

    // Extract device info from query_object or raw_result
    const deviceId = this.extractDeviceId(query_object);
    const deviceName = query_object.device_name || this.extractDeviceName();

    if (!deviceId) {
      console.warn('DeviceConfigToolResult: No device ID found in tool data');
      return Promise.resolve(null);
    }

    // Create a minimal DeviceModel with the data we have
    const deviceData = {
      id: deviceId,
      device_name: deviceName || `Device ${deviceId}`,
      // Add any other device properties from raw_result if available
      vendor: this.extractVendor()
    };

    const device = new DeviceModel(deviceData);
    this.setState({ device });
    return Promise.resolve(device);
  };

  extractDeviceId = (queryObject) => {
    // Try to get deviceId from query_object
    if (queryObject.deviceId) {
      return queryObject.deviceId;
    }

    // Try to extract from processed_result text (e.g., "device name (ID: 12345)")
    const { tool } = this.props;
    const processedResult = tool.processed_result || '';
    const idMatch = processedResult.match(/\(ID:\s*(\d+)\)/);
    if (idMatch && idMatch[1]) {
      return idMatch[1];
    }

    return null;
  };

  extractDeviceName = () => {
    // Device name might be in the query_object already
    const { tool } = this.props;
    const processedResult = tool.processed_result || '';

    // Try to extract from processed_result text (e.g., "device device_name (ID: 12345)")
    const nameMatch = processedResult.match(/device\s+([^\s(]+)\s*\(/);
    if (nameMatch && nameMatch[1]) {
      return nameMatch[1];
    }

    return null;
  };

  extractVendor = () => null;

  render() {
    const { tool, onCloseToolResult, isInlineMode } = this.props;
    const { device } = this.state;

    if (!device) {
      return (
        <ToolResultCard
          tool={tool}
          onCloseToolResult={onCloseToolResult}
          isInlineMode={isInlineMode}
          className="tool-result-device-config"
          title={tool.title || 'Device Configuration History'}
        >
          <Flex flexDirection="column" px={2} py={2} alignItems="center" justifyContent="center">
            Unable to load device configuration viewer. Device information not available.
          </Flex>
        </ToolResultCard>
      );
    }

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-device-config"
        title={tool.title || 'Device Configuration History'}
      >
        <Flex flexDirection="column" flex={1} minHeight="500px">
          <DeviceConfigs device={device} standalone />
        </Flex>
      </ToolResultCard>
    );
  }
}

export default DeviceConfigToolResult;
